<template>
  <div
    class="lego-dropdown lego-input"
    :class="dropdownClass"
    :style="[dropdownWidth, dropdownHeight, cursor]"
    v-click-outside="toggleItemOuter"
  >
    <div v-show="errorMessage && !underMessage && !dropdownErrorMessage" class="error-message">
      {{ errorMessage }}
    </div>
    <div
      class="lego-dropdown__title"
      :class="{ 'is-item-showing': isItemShowing, 'detail-filter': modeDetailFilter }"
      @click="toggleItem"
    >
      <div class="lego-dropdown__selected" ref="widthDiv" :style="dropdownTitleStyle">
        <div
          style="display: flex"
          v-lego-tooltip="{
            value: tooltip ? tooltip : textToolTip,
            arg: tooltip ? '' : 'ellipsis',
            moreAction: 'clickToHide'
          }"
        >
          <span style="width: auto; text-overflow: ellipsis; max-width: 100%">
            <span style="text-overflow: ellipsis; width: 100%">
              {{ capitalize ? this.$util.capitalize(textSelected) : textSelected }}
            </span>
          </span>
          <span
            v-if="isMultiSelected && countSelected"
            style="text-overflow: unset; min-width: max-content; margin-left: 3px"
          >
            {{ countSelected }}
          </span>
        </div>
      </div>

      <lego-icon-wrapper style="width: 18px; margin-left: 12px">
        <lego-icon
          class="lego-dropdown__icon"
          icon-type="df"
          icon="arrow_down"
          size="16px"
          :style="caretStyle"
        />
      </lego-icon-wrapper>
    </div>
    <div
      ref="downWrap"
      class="lego-dropdown__downwrap"
      :style="getStyleDropdown"
      v-if="isItemShowing"
    >
      <div class="lego-dropdown__tags">
        <div v-if="hasSearchField && items.length" style="padding: 12px 12px 0px 12px">
          <lego-text-field
            ref="filterInput"
            :placeholder="searchPlaceholder || $t('label.all')"
            v-model="filterText"
            searchable
            counter="100"
            :isCounter="false"
            :isFreeText="true"
            :disableInputMutation="true"
            @update:modelValue="filterTextOnInput"
          />
          <!-- :mutateInput="mutateInput" this Prop for lego text filed - old code -->
        </div>
        <div
          v-show="errorMessage && dropdownErrorMessage"
          class="error-message"
          style="padding-left: 12px"
        >
          {{ errorMessage }}
        </div>
        <div v-if="listSearch.length" class="lego-dropdown__selectall-wrap">
          <div
            v-if="!filterText"
            v-show="selectAll"
            class="lego-dropdown__item lego-dropdown__selectall"
            @click="onSelectAll"
          >
            <lego-checkbox
              :indeterminate="!!(selected.length && selectAllCheckedIcon === 'indeterminate')"
              :checked="!!selected.length"
              :checked-icon="selectAllCheckedIcon"
              :disabled="isDisabledAll"
              @click="onSelectAll"
              >{{ $t('label.all') }}
            </lego-checkbox>
          </div>
        </div>
        <span class="search-result" v-if="items.length && filterText">{{ searchResult }}</span>
        <c-scroll
          :style="
            listSearch.length
              ? {
                  maxHeight: isMontargetCustomCommon
                    ? '267px'
                    : listSearch.length > 8
                    ? '272px'
                    : 'auto'
                }
              : ''
          "
        >
          <div v-if="!items.length" class="no-result">
            <NullWidget style="min-height: 134px" />
          </div>
          <div v-else-if="!listSearch.length" class="no-result">
            {{ t('label.noSearchResult') }}
          </div>

          <div class="lego-dropdown__items">
            <div
              class="lego-dropdown__item"
              :class="{ 'item-checked': isItemChecked(item) }"
              v-for="(item, idx) in listSearch"
              :key="idx"
              @click="onClickOption(item)"
            >
              <div v-if="item.key" class="lego-dropdown__label">
                <lego-checkbox
                  :value="item"
                  :checked="selected"
                  :disabled="item.disabled"
                  @click="onClickOption(item)"
                  :valueKey="valueKey"
                >
                  <em
                    v-if="!modeAsg"
                    class="ellipsis"
                    v-lego-tooltip="{
                      value: getOptionLabel(item, true),
                      arg: 'ellipsis'
                    }"
                    v-html="getOptionLabel(item)"
                  />
                  <em
                    v-else
                    class="ellipsis"
                    v-lego-tooltip="{
                      value: getOptionLabel(item, true, modeAsg),
                      class: 'scp-asg',
                      isShowHTML: true
                    }"
                    v-html="getOptionLabel(item)"
                  />
                </lego-checkbox>
              </div>
            </div>
          </div>
        </c-scroll>
      </div>
    </div>
    <div v-show="errorMessage && underMessage && !dropdownErrorMessage" class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import i18nMixin from '@/mixins/i18n.mixin.js';
import legoDropdown from '@/lego-component/components/element/legoDropdown/legoDropdown.vue';
import cScroll from '../../cmp/cScroll/cScroll.vue';
import NullWidget from '@/containers/widget/components/NullWidget.vue';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';

export default {
  mixins: [i18nMixin],
  name: 'scpm-select-box',
  components: { cScroll, NullWidget },
  extends: legoDropdown,
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [Array, String],
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    mutateInput: { type: Function, default: null },
    hasSearchField: { type: Boolean, default: false },
    showOnlyText: { type: Boolean, default: true },
    searchPlaceholder: { type: String, default: '' },
    textAll: { type: String, default: '' },
    selectedPlaceholder: { type: String, default: '' },
    maxSelect: { type: [Number, String], default: 100 },
    messageErrorMaxSelect: { type: String, default: '' },
    dropdownErrorMessage: { type: Boolean, default: false },
    valueKey: { type: Array, default: () => ['key'] },
    selectAll: {
      type: Boolean,
      default: false
    },
    showTop: { type: Boolean, default: false },
    underMessage: {
      type: Boolean,
      default: false
    },
    capitalize: {
      type: Boolean,
      default: false
    },
    isMontargetCustomCommon: {
      type: Boolean,
      default: false
    },
    modeDetailFilter: {
      type: Boolean,
      default: false
    },
    modeAsg: {
      type: Boolean,
      default: false
    },
    tooltip: { type: String, default: '' }
  },

  data() {
    return {
      filterText: '',
      selected: [],
      textToolTip: '',
      textSelected: this.selectedPlaceholder || this.$t('label.all'),
      countSelected: '',
      errorMessage: '',
      searchResult: '',
      listSearch: []
    };
  },

  computed: {
    getStyleDropdown() {
      let style = {};

      if (this.showTop) {
        style.bottom = '31px';
      }

      return style;
    },
    isMultiSelected() {
      return this.selected.length > 1;
    },

    dropdownTitleStyle() {
      return { color: this.selected.length && !this.modeDetailFilter ? '#000' : '#a5a7ad' };
    },

    selectAllCheckedIcon() {
      const counter = this.hasSearchField
        ? this.listSearch.filter((item) => !item.disabled).length
        : this.items.filter((item) => !item.disabled).length;
      return this.selected.length === counter ? 'checked' : 'indeterminate';
    },

    isDisabledAll() {
      return !this.listSearch.filter((item) => !item.disabled).length;
    },

    dataChange() {
      return [this.items, this.selected];
    },
    cursor() {
      if (!this.modeDetailFilter) {
        return null;
      }
      return { cursor: 'default' };
    }
  },

  watch: {
    modelValue: {
      handler(val) {
        if (!val) {
          this.selected = [];
        }
        if (val && !_.isEqual(this.selected, val)) {
          this.selected = val.slice();
        }
      },
      deep: true,
      immediate: true
    },
    dataChange: {
      handler(val) {
        this.getSelectedItemText();
        if (this.maxSelect && val.length <= this.maxSelect) this.errorMessage = '';
      },
      deep: true,
      immediate: true
    },
    errorMessage(val) {
      this.hasError = !!val.length && !this.dropdownErrorMessage;
    },
    filterText: {
      handler() {
        this.changeHeightDownwrap();
        this.errorMessage = '';
        this.getFilterItems();
      },
      deep: true,
      immediate: true
    },
    items: {
      handler() {
        this.getFilterItems();
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.getFilterItems();
    legoEventBus.$on('click-outside', () => this.toggleItemOuter());
  },

  beforeUnmount() {
    legoEventBus.$off('click-outside', () => this.toggleItemOuter());
  },

  methods: {
    changeHeightDownwrap() {
      this.$nextTick(() => {
        this.$emit('changeHeightDownwrap');
      });
    },
    getFilterItems() {
      if (this.selectAll) this.searchResult = '';
      if (!this.items) return (this.listSearch = []);
      if (!this.filterText) return (this.listSearch = _.cloneDeep(this.items));

      const searchText = this.filterText.toLowerCase();

      this.listSearch = this.items.filter((item) => {
        const lowerText = (item.text || '').toLowerCase();
        const lowerValue = (item.key || '').toString().toLowerCase();
        if (item.text) return lowerText.includes(searchText);
        return lowerValue.includes(searchText);
      });

      this.searchResult = this.$t('label.searchResultParam', ['(' + this.listSearch.length + ')']);
    },
    isItemChecked(item) {
      return this.selected.some(
        (itemAll) => !this.valueKey.some((val) => itemAll[val] !== item[val])
      );
    },

    filterTextOnInput(value) {
      this.filterText = value;
    },

    getSelectedItemText() {
      this.countSelected = '';
      let itemText = '';
      if (!this.selected.length) {
        this.textSelected = this.selectedPlaceholder || this.$t('label.all');
        this.textToolTip = this.textSelected;
        return;
      }

      if (this.selected.length === this.items.length) {
        this.textSelected = this.textAll || this.$t('label.all');
        this.textToolTip = this.textSelected;
        return;
      }

      if (this.selected[0]) {
        itemText = this.selected[0].text || this.selected[0].value || '';
      }

      if (!this.showOnlyText) {
        itemText = `${this.selected[0].key.toString()}:${itemText}`;
      }

      this.textToolTip = itemText;
      this.textSelected = itemText;

      const count = this.selected.length;

      if (count > 1) {
        this.textToolTip = this.textToolTip + ' ' + this.$t('label.andOther', [count - 1]);
        this.countSelected = this.$t('label.andOther', [count - 1]);
      }
    },

    getOptionLabel(item, isTooltip = false, modeAsg = false) {
      const textDefault = item.text || item.value || '';
      let itemText = this.showOnlyText ? textDefault : `${item.key}:${textDefault}`;
      if (itemText.length && this.capitalize) {
        itemText = this.$util.capitalize(itemText);
      }
      if (modeAsg) {
        return `
          <div>
            <span>${this.$t('searchLabel.asgName')}:</span>
            <span>${this.$util.escapeHTML(item.text)}</span>
          </div>
          <div>
            <span >${this.$t('searchLabel.asgId')}:</span>
            <span>${this.$util.escapeHTML(item.groupIfKey)}</span>
          </div>
`;
      }
      itemText = this.$util.escapeHTML(itemText);
      if (isTooltip || this.filterText === '') return itemText;
      const regex = this.$util
        .escapeHTML(this.filterText)
        .replace(/[!@#$%^&*()+=\-[\]\\';,./{}|":<>?~_]/g, '\\$&');

      return itemText.replace(
        new RegExp(regex, 'ig'),
        (w) => `<span style='color:#2c59d9'>${w}</span>`
      );
    },

    isCheckValueKeyTypeOfArray(item, itemCheck) {
      return !this.valueKey.some((val) => item[val] !== itemCheck[val]);
    },

    onClickOption(item) {
      if (item.disabled) return;

      let selectedIndex = -1;

      selectedIndex = this.selected.findIndex(
        (itemAll) => !this.valueKey.some((val) => itemAll[val] !== item[val])
      );

      if (selectedIndex > -1) {
        this.selected.splice(selectedIndex, 1);
      } else {
        if (this.maxSelect && this.selected.length == this.maxSelect) {
          this.errorMessage = this.messageErrorMaxSelect;
          return;
        }

        this.selected.push({ ...item });
      }

      this.$emit('update:modelValue', this.selected);
    },

    toggleItem() {
      if (this.modeDetailFilter) return;
      this.isItemShowing = !this.isItemShowing;
    },

    toggleItemOuter(event) {
      if (!event || !event.target.closest('.authorization-modal-wrapper')) {
        this.isItemShowing = false;
        this.errorMessage = '';
      }
    },

    validateSelected(options) {
      if (this.maxSelect && options.length > this.maxSelect) {
        this.errorMessage = this.messageErrorMaxSelect;
        return false;
      }
      return true;
    },

    onSelectAll() {
      const enableOptions = this.items.filter((item) => !item.disabled);
      if (!this.validateSelected(enableOptions)) return;

      if (this.selectAllCheckedIcon == 'checked') {
        this.selected = [];
      } else {
        const filterNonDisabledItem = this.listSearch.filter((item) => !item.disabled);
        this.selected = [...filterNonDisabledItem];
      }

      this.$emit('update:modelValue', this.selected);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-result {
  padding-left: 12px;
  font-size: 12px;
  color: #999999;
}

.no-result {
  cursor: default;
  padding: 25px 0;
  text-align: center;
  font-size: 11px;
  color: #858585;
}

.error-message {
  font-size: 12px;
  color: #fb4b57;
}

.lego-dropdown {
  min-width: 80px;
  width: 100%;
  &__title {
    border-radius: 2px;

    &.is-item-showing {
      border-color: $lego-dropdown__title__border--focus;
    }

    .lego-dropdown__selected {
      display: block;
      line-height: 30px;
      width: calc(100% - 24px);
      color: #a5a7ad;
      span {
        display: inline-block;
        @include ellipsis;
      }

      &.placeholder {
        color: $color--ui06;
      }
    }
  }

  &__title-icon {
    .lego-dropdown__icon {
      font-size: 12px;
    }
  }
  .detail-filter {
    border: 1px solid #bbbdc1 !important;
    color: #bbbdc1 !important;
    background-color: #f3f4f4 !important;
  }

  .lego-dropdown__title {
    &:focus {
      border: $lego-dropdown__title__border;
    }
    &:hover {
      border-color: $lego-dropdown__title__border--focus;
    }
  }

  &--readonly {
    pointer-events: none;
    cursor: default;
    .lego-dropdown__title {
      border: $lego-dropdown__title__border--disabled;
      background-color: $lego-dropdown__title__background-color--readonly;
    }
  }

  &--disabled {
    .lego-dropdown__title {
      .lego-dropdown__selected {
        color: #a5a7ad !important;
      }
    }
  }
}

:deep .lego-button--border.lego-button--default {
  font-weight: 700;
  background-color: #364fc7;
  border-color: #364fc7;
  color: #ffffff;
  font-size: 12px;
  line-height: 18px;
  border-radius: 2px;
  height: 24px;
  min-width: 70px;
  padding: 0 8px;
  cursor: pointer;

  &:hover {
    background-color: #2b3f9f;
    border-color: #2b3f9f;
  }
}

:deep .lego-dropdown__downwrap {
  width: 100%;
}

.lego-dropdown__tags {
  background-color: #ffffff;
  border: 1px solid #364fc7;
}
:deep .lego-dropdown__item {
  padding: 0 12px 0 12px;

  &.item-checked,
  &:hover {
    background-color: #eff1fb;
    .lego-dropdown__label {
      .lego-checkbox__label {
        color: #2f3237;
        font-weight: 400;
      }
    }
  }
}
:deep .lego-dropdown__selectall {
  display: block !important;
  border: 0;
  border-bottom: 1px solid #e4e5e7;
  line-height: 24px;
  min-height: 34px;
  max-height: 48px;

  .lego-dropdown__item .lego-checkbox__checked + .lego-checkbox__label,
  .lego-checkbox__label {
    color: #2f3237 !important;
    font-weight: 700;
    padding-top: 1px;
  }
  &:hover {
    background-color: #eff1fb !important;
  }
}
:deep .lego-dropdown__items {
  max-height: initial;
  border: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}
.lego-dropdown__selectall-wrap {
  padding: 0 0px;

  .lego-dropdown__item {
    &:hover {
      background-color: transparent;
    }
  }
}
.lego-dropdown__apply-wrap {
  padding: 0 10px;
}

:deep .lego-dropdown__apply {
  border: 0;
  border-top: 1px solid #a5a7ad;
}
:deep .lego-button--default:not(.lego-button--loading):hover {
  background-color: #2b3f9f !important;
}
:deep .lego-checkbox__label {
  display: block;
  width: calc(100% - 10px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #2f3237;
  padding-top: 1px;

  em {
    display: block;
    font-style: normal;
    @include ellipsis;
  }
}
:deep .lego-dropdown__label {
  flex: 0 1 auto;
  display: block;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
}
:deep .lego-checkbox {
  display: block;
  flex: 0 1 auto;
  align-items: flex-start;
  padding: 5px 0 0 15px;
  &--disabled .lego-checkbox__label {
    color: #2f3237 !important;
  }
}
:deep .lego-checkbox__icon {
  position: absolute;
  top: 8px;
  left: 0;
}
</style>
